















import Vue from "vue"

export default Vue.extend({
  name: "FilterContainer",
  props: ['allRoutes'],
  data () {
    return {
      checkedValues: []
    }
  },
  methods: {
    idString (id:number) {
      return `route-${id}`
    },
    resetChecked () {
      this.checkedValues = []
      Array.from(document.querySelectorAll('input[type=checkbox]')).forEach((element:any) => {
        element.checked = false
      });
    }
  },
  watch: {
    checkedValues (newVal, oldVal) {
      this.$emit('change', newVal)
    }
  }
})



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FilterContainer.vue